if (!customElements.get('birthday-gift-container')) {
  customElements.define('birthday-gift-container', class BirthdayGiftContainer extends HTMLElement {
    constructor() {
      super();
      this.onCartAdd = this.onCartAdd.bind(this);
      this.sectionId = this.dataset.sectionId; 

      this.onCartRemove = this.onCartRemove.bind(this);
    }

    connectedCallback() {
      if (!this.sectionId) {
        this.sectionId = this.dataset.sectionId;
      }

      document.addEventListener('rebuy:cart.change', this.onCartAdd);

    }

    disconnectedCallback() {
      document.removeEventListener('rebuy:cart.change', this.onCartAdd);
      //document.removeventListener('rebuy:smartcart.product-removed', this.onCartRemove);
    }

    onCartAdd(event) {
      // Re-render the section when Rebuy adds to cart
      this.renderBirthdayGiftSection();
    }
    
    onCartRemove(event) {
      // Re-render the section when Rebuy adds to cart
      this.renderBirthdayGiftSection();
    }

    renderBirthdayGiftSection() {
      console.log('this.sectionId', this.sectionId);
      if (!this.sectionId) return;

      const url = `${window.location.pathname}?section_id=${encodeURIComponent(
        this.sectionId
      )}`;

      fetch(url, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
          .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.text(); // get raw HTML string
          })
            .then ((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');

              // Now query the parsed DOM
              const birthdayContent = doc.querySelector('birthday-gift-container[data-section-id]');
              const birthdayMessage = doc.querySelector('.section-head p');
              const updatedBirthdayContent = birthdayContent ? birthdayContent.innerHTML : null;
              const updatedbirthdayMessage = birthdayMessage ? birthdayMessage.innerHTML : null;

              console.log(updatedbirthdayMessage);
              this.innerHTML = updatedBirthdayContent
              document.querySelector(`#shopify-section-${this.sectionId} .section-head p`).innerHTML = updatedbirthdayMessage
            })

      // Example: fetch the section HTML and replace content
      // fetch(url)
      //   .then(res => res.text())
      //   .then(html => {
      //     this.innerHTML = html;
      //   });
    }
  });
}


if (!customElements.get('product-form-gift')) {
  customElements.define('product-form-gift', class ProductFormGift extends HTMLElement {
    constructor() {
      super(); 

    }

    connectedCallback() {

      this.form = this.querySelector('form');
      if(this.form) {
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      // but this would only apply for native dawn cart-drawer and cart page 
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
    //   if (window.Rebuy && window.Rebuy._status !== 'initialized') {
    //     //this.disableForm();
    //     console.log("window.Rebuy && window.Rebuy._status !== 'initialized'")
    //   }
    }

    disableForm() {
      if(this.submitButton) {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        // 🔹 Actually disable the button
        this.submitButton.disabled = true;
      }

      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');
    }

    enableForm() {
      //console.log('form-enabled')
      if(this.submitButton) {
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
      }

      this.querySelector('.loading-overlay__spinner').classList.add('hidden');

    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      // This line serializes the entire <form> element into key/value pairs.
      const formData = new FormData(this.form);

      console.log(Object.fromEntries(formData.entries()));

      // sliding add to cart button code
      // we will show the loading spinner icon here
      if(document.querySelector('.sliding-add-to-cart-container.show-sliding-cart .loading-overlay__spinner')) {
            document.querySelector('.sliding-add-to-cart-container.show-sliding-cart .loading-overlay__spinner').classList.remove('hidden');
      }

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // using the formData mode
      // ✔ Removes JSON headers
      // ✔ Removes Content-Type
      // ✔ Allows the browser to set multipart/form-data; boundary=----..
      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };


      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      this.productId = this.form.id.getAttribute('data-productid');
      console.log('config.body', config.body)
      fetch(`${routes.cart_add_url}.js`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } 
          
          // even if the native cart drawer is missing, we still need to prevent from going to the cart page
          // else if (!this.cart) {
          //   this.addFreeSubscriptionProduct(this);
          //   window.location = window.routes.cart_url;
          //   return;
          // }

          this.error = false;
          const resp = this.addFreeSubscriptionProduct(this);
          if(!resp) {
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          }

          setTimeout(() => {
            this.cart && this.cart.open(); // short circuit if cart is null then cart open will not run
          }, 100);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.disableForm()
        });
    }

    async getProductBySlug(slug) {
      const response = await fetch(window.Shopify.routes.root + 'products/' + slug +'.js', { ...getConfig() })
      if (!response.ok) {
        return null;
      } else {
        const product =  await response.json();
        return product;
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    addFreeSubscriptionProduct(evt) {
        return true;
    }

  });

}